import React, { useEffect, useState } from 'react';
import '../css/footer.css';
import Copyright from "../components/copyright";
import SocialMedia from "../components/socialMedia";
import { api } from "../services";
import { useLocalization } from "../context/localization";

const Footer = () => {
    const [footerData, setFooters] = useState(null);
    const { language } = useLocalization();

    useEffect(() => {
        const fetchFooterData = async () => {
            try {
                const response = await api.general.getFooter(language);
                const data = response?.data?.data?.[0]?.attributes?.Footer?.[0];
                if (data) {
                    setFooters(data);
                }
            } catch (error) {
                console.error('Error fetching footer data:', error);
            }
        };

        fetchFooterData();
    }, [language]);

    if (!footerData) {
        return <footer>Loading...</footer>;
    }

    return (
        <footer className={"footer"}>
            <Copyright
                title={footerData.copyright?.title}
                logoUrl={footerData.copyright?.Logo?.data?.attributes?.url}
            />
            <SocialMedia
                socialMedia={footerData.socialMedia}
                title={footerData.socialMediaTitle}
            />
        </footer>
    );
};

export default Footer;